export const viewableFileFormats = ['gif', 'jpg', 'jpeg', 'png']
export const fileTypesWithIcons = ['csv', 'excel', 'rtf', 'word', 'txt', 'pdf', 'xml']  // some of most common slds supported file icon types

export const isExcelFile = (fileExtension) =>
  ['xls', 'xlsx'].indexOf(fileExtension) > -1

export const isWordFile = (fileExtension) =>
  ['doc', 'docx'].indexOf(fileExtension) > -1

export const getSldsIconType = (fileExtension) => {
  if (viewableFileFormats.indexOf(fileExtension) > -1) {
    return "image"
  }

  if (isExcelFile(fileExtension)) {
    return "excel"
  }

  if (isWordFile(fileExtension)) {
    return "word"
  }

  if (fileTypesWithIcons.indexOf(fileExtension) > -1) {
    return fileExtension
  } else {
    return "unknown"
  }
}

export const isViewableFileFormat = (fileExtension) => (
  viewableFileFormats.indexOf(fileExtension.toLowerCase()) > -1
)

export const getFileExtension = (string) => (  // expects filename or url as string param
  string.split('.').pop()
)



// WEBPACK FOOTER //
// ./src/utils/file/index.js